import * as Sentry from '@sentry/react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface AiReport {
  id?: number | string;
  _id?: number | string;
  title?: string;
  html?: string;
  fileSize?: number;
  createdAt?: string | number | Date;
  sourceUser?: { username?: string; [key: string]: unknown } | null;
  [key: string]: unknown;
}

interface AiReportViewerProps {
  report: AiReport;
}

function AiReportViewerContent({ report }: AiReportViewerProps) {
  const formattedDate = new Date(report.createdAt as string | number | Date).toLocaleString();

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">{report.title}</Typography>
        <Typography variant="body2" sx={{
          color: "text.secondary"
        }}>
          Uploaded: {formattedDate}
        </Typography>
        <Typography variant="body2" sx={{
          color: "text.secondary"
        }}>
          Source: {report.sourceUser && report.sourceUser.username}
        </Typography>
      </Box>
      <Box
        component="iframe"
        sandbox=""
        srcDoc={report.html}
        title={report.title}
        sx={{
          width: '100%',
          height: '70vh',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
        }}
      />
    </Box>
  );
}

export default function AiReportViewer({ report }: AiReportViewerProps) {
  return (
    <Sentry.ErrorBoundary fallback={<Typography color="error">Failed to render report.</Typography>}>
      <AiReportViewerContent report={report} />
    </Sentry.ErrorBoundary>
  );
}
